/** @typedef {import('../index.js').InvalidDocData} InvalidDocData */
/** @typedef {import('./tuningHistory.js').TuningHistoryDocData} TuningHistoryDocData */

import TuningHistory, { TUNING_HISTORY_STATUS } from './tuningHistory.js';

function tuningHistoryFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return TuningHistory.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming tuning history data:', docData.id, error);
    /** @type {InvalidDocData} */
    const InvalidDocData = { validation: 'failed', ...docData };
    return InvalidDocData;
  }
}

function tuningHistoryToFirestore(tuningHistory) {
  return new TuningHistory(tuningHistory).toFirestore();
}

export {
  TUNING_HISTORY_STATUS,
  tuningHistoryFromFirestore,
  tuningHistoryToFirestore,
};
